import React from 'react'
import OptionGroupBar from './OptionGroupBar.js'
import './OptionGroup.css'

const OptionGroup = ({ options }) => {
  if (!options || options.length < 2) return null
  const firstOption = options[0]
  const lastOption = options[options.length - 1]

  return (
    <div className="OptionGroup-options">
      <div className="OptionGroup-label small mobile--hide lh-medium">
        {firstOption.body}
      </div>
      <OptionGroupBar options={options} />
      <div className="OptionGroup-label small mobile--hide lh-medium">
        {lastOption.body}
      </div>
    </div>
  )
}

export default OptionGroup



// WEBPACK FOOTER //
// ./src/components/OptionGroup.js